import "./Footer.scss";

function Footer() {
  return (
    <div className="footer">
      <p className="footer__text">
        <span className="footer__symbol">©</span>InStock Inc. All Rights
        Reserved.
      </p>
    </div>
  );
}

export default Footer;
